<template>
    <div>
        <b-row>
            <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <b-card class="sa-card sa-card-border" header="Anamnesi PsichiatricaRemota" header-tag="header" footer-tag="footer" title="">
                    <b-row>
                        <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                            <span v-if="isReadOnly">{{ jsonDataAnamnesiPsichiatricaRemota.voce }}</span>
                            <b-form-textarea v-else v-model="jsonDataAnamnesiPsichiatricaRemota.voce" :readonly="isReadOnly" max-rows="10" rows="8"> </b-form-textarea>
                        </b-col>
                    </b-row>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>
<script>
import UtilityMixin from "../../../utility/UtilityMixin";

export default {
    props: {
        isReadOnly: {
            type: Boolean,
            default: false,
        },
        idAccettazione: {
            type: String,
        },
        jsonDataAnamnesiPsichiatricaRemota: {
            type: Object,
            default: function () {
                return {
                    id: null,
                    idAccettazione: this.idAccettazione,
                    voce: "",
                };
            },
        },
    },
    mixins: [UtilityMixin],
    watch: {
        jsonDataAnamnesiPsichiatricaRemota: {
            handler(jsonData) {
                this.$emit("update", jsonData);
            },
            deep: true,
        },
    },
    data() {
        return {
            pathResourceSchedaRelazioneSanitariaAnamnesiPsichiatricaRemota: "/rsaschedarelazionesanitariaanamnesipsichiatricaremota",
        };
    },
    methods: {
        loadSchedaRelazioneSanitariaAnamnesiPsichiatricaRemota() {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathResourceSchedaRelazioneSanitariaAnamnesiPsichiatricaRemota + "/accettazione/" + me.idAccettazione, {}, me.resultResponseSchedaRelazioneSanitariaAnamnesiPsichiatricaRemotaSuccess, me.resultResponseSchedaRelazioneSanitariaAnamnesiPsichiatricaRemotaError);
        },

        resultResponseSchedaRelazioneSanitariaAnamnesiPsichiatricaRemotaSuccess(response) {
            let me = this;
            me.jsonDataAnamnesiPsichiatricaRemota = response.data.data;
        },

        resultResponseSchedaRelazioneSanitariaAnamnesiPsichiatricaRemotaError(error) {
            let me = this;
            if (error.response && error.response.status === 404) {
                me.resetForm();
            }
        },

        resetForm() {
            let me = this;
            me.jsonDataAnamnesiPsichiatricaRemota = {
                id: null,
                idAccettazione: me.idAccettazione,
                voce: null,
            };
        },

        onAnamnesiPsichiatricaRemota() {
            let me = this;
            me.jsonDataAnamnesiPsichiatricaRemota.idAccettazione = me.idAccettazione;
            if (!me.jsonDataAnamnesiPsichiatricaRemota.idAccettazione) {
                me.$bvToast.toast("Errore: ID Accettazione mancante", {
                    title: "Errore",
                    variant: "danger",
                    solid: true,
                });
                return;
            }
            UtilityMixin.methods.saveResource(me.pathResourceSchedaRelazioneSanitariaAnamnesiPsichiatricaRemota, me.jsonDataAnamnesiPsichiatricaRemota, me.saveSchedaRelazioneSanitariaAnamnesiPsichiatricaRemotaSuccessResponse, me.saveSchedaRelazioneSanitariaAnamnesiPsichiatricaRemotaErrorResponse);
        },
        saveSchedaRelazioneSanitariaAnamnesiPsichiatricaRemotaSuccessResponse() {},
        saveSchedaRelazioneSanitariaAnamnesiPsichiatricaRemotaErrorResponse() {
            console.error("Errore nel salvataggio anamnesi psichiatricaremota:");
        },
    },
};
</script>
